import { render, staticRenderFns } from "./AllArticles.vue?vue&type=template&id=26d48c59"
import script from "./AllArticles.vue?vue&type=script&lang=js"
export * from "./AllArticles.vue?vue&type=script&lang=js"
import style0 from "./AllArticles.vue?vue&type=style&index=0&id=26d48c59&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports